// extracted by mini-css-extract-plugin
module.exports = {"list":"_9370"};